<!-- 
	Alert
	props: N/A
  role: Public
	Called across the application to display an alert mostly within form components
-->

<template>
	<div
		class="
      alert
      bg-red-100
      bordder
      border-red-400
      text-red-700
      px-4
      py-3
      rounded
      relative
    "
		role="alert"
	>
		<slot />
	</div>
</template>

<script>
	export default {
		name: "Alert",
	};
</script>
